import axios from "axios";

export const getRceDashboardList = async (req: any): Promise<any> => {
    const params = new URLSearchParams();
    params.set("filter", JSON.stringify(req.filter));
    const response = await axios.get('/booking/rce-dashoboard/v1/list', { params });
    return response.data;
};
